import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-20ead0f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col items-center w-full h-full paddingContainer overflow-y-auto" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-auto mt-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-primary text-md text-center" }, "Welcome to CRYSTASURE !"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-black text-xs text-center mt-1" }, "To get the best experience, we recommend you to complete these onboarding steps")
], -1))
const _hoisted_3 = { class: "bg-white overflow-y-auto flex flex-col justify-between border mt-3 border-lightgrey rounded infoContainer w-full p-3" }
const _hoisted_4 = { class: "flex flex-col justify-center items-center h-full" }
const _hoisted_5 = { class: "text-primary text-sm font-semibold mb-1" }
const _hoisted_6 = { class: "text-xs text-black" }
const _hoisted_7 = { class: "flex justify-center items-center" }
const _hoisted_8 = { class: "w-3/4 flex justify-between items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tab.id,
          class: "w-3/4 box border border-lightgrey mb-2 mx-auto rounded-sm"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(tab.name), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(tab.statement), 1)
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack())),
            class: "btnprimary strokeButton h-7 w-16 flex justify-center items-center"
          }, "Cancel"),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startOnBoardProcess())),
            class: "btnprimary nextButton h-7 w-16 flex justify-center items-center"
          }, "Start")
        ])
      ])
    ])
  ]))
}